import { ResolvedIcon } from "@/features/adp/components/shared/ResolvedIcon";
import { Button } from "@/ui/button";
import { AlertTriangle } from "lucide-react";
import PrerequisiteDialog from "../dialogs/PrerequisiteDialog";

interface PickerDetailsHeaderProps {
    imageLink: string | null | undefined;
    sourceName: string | null | undefined;
    label?: string;
    type: 'source' | 'destination';
    prerequisite: Record<string, unknown>;
}

const PickerDetailsHeader = ({
    imageLink,
    sourceName,
    label = "Source Name",
    type,
    prerequisite
}: PickerDetailsHeaderProps) => {
    return (
        <div className="-mx-3 border-b border-border px-3 pb-4">
            <div className="flex items-start gap-4">
                <div className="flex h-20 w-20 items-center justify-center rounded-md border border-primary/50">
                    <ResolvedIcon
                        imageLink={imageLink ?? null}
                        alt={sourceName ?? "selected source"}
                        className="h-16 w-16 object-contain"
                    />
                </div>
                <div className="space-y-2">
                    <div className="flex items-center gap-2">
                        <span className="text-sm font-medium text-muted-foreground">{label} :</span>
                        <span className="text-sm font-medium capitalize">{sourceName ?? "-"}</span>
                    </div>
                    <PrerequisiteDialog type={type} prerequisite={prerequisite}>
                        <Button type="button" variant="text">
                            <AlertTriangle />
                            Prerequisites
                        </Button>
                    </PrerequisiteDialog>
                </div>
            </div>
        </div>
    );
};

export default PickerDetailsHeader;
